module.exports = __webpack_public_path__ + "img/g11.8b6ddd41.jpg";